import {
  ChangeDetectionStrategy,
  Component,
  forwardRef,
  HostListener,
  Input,
  OnChanges,
  SimpleChanges,
} from '@angular/core';
import { ControlValueAccessor, NG_VALUE_ACCESSOR } from '@angular/forms';
import { BaseComponent } from '@macs-frontend/core';

@Component({
  selector: 'md-tag-dropdown',
  templateUrl: 'tag-dropdown.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => TagDropdownComponent),
      multi: true,
    },
  ],
})
export class TagDropdownComponent
  extends BaseComponent
  implements ControlValueAccessor, OnChanges
{
  @Input() options: any[] = [];
  // @ts-expect-error
  @Input() labelKey: string | number;
  // @ts-expect-error
  @Input() valueKey: string | number;
  @Input() compareKey: any;
  // @ts-expect-error
  @Input() placeholder: string;

  chosenOption: any;
  showDropdown = false;
  // @ts-expect-error
  label: string;

  get model() {
    return this.modelValue;
  }
  set model(value) {
    this.writeValue(value);
    this.onChangeCallback(value);
  }

  private modelValue: any;

  onChangeCallback = (_: any) => {};

  @HostListener('document:mousedown')
  documentMouseDown() {
    this.showDropdown = false;
  }

  @HostListener('mousedown', ['$event'])
  mousedown(e: { stopPropagation: () => void }) {
    e.stopPropagation();
  }

  ngOnChanges(changes: SimpleChanges) {
    // eslint-disable-next-line sonarjs/no-collapsible-if
    if (changes.options) {
      if (!this.chosenOption) {
        this.setChosenOptionByModel(this.model);
      }
    }
  }

  writeValue(value: any) {
    this.modelValue = value;
    this.setChosenOptionByModel(value);
  }

  registerOnChange(fn: (_: any) => void) {
    this.onChangeCallback = fn;
  }

  registerOnTouched() {}

  // eslint-disable-next-line sonarjs/cognitive-complexity
  setChosenOptionByModel(model: { [x: string]: any }) {
    if (this.options) {
      const key = !this.valueKey && this.compareKey ? this.compareKey : this.valueKey;
      const useWholeModel = this.valueKey || !this.compareKey;
      this.chosenOption =
        !useWholeModel && !model
          ? null
          : this.options.find(
              (option: any) =>
                (key ? option[key] : option) === (useWholeModel ? model : model[key]),
            );
      this.setLabel(this.chosenOption);
    }
  }

  selectValue(option: any): void {
    this.chosenOption = option;
    this.setLabel(option);
    this.model = this.valueKey ? option[this.valueKey] : option;
    this.showDropdown = false;
  }

  resetLabel() {
    if (this.chosenOption) {
      this.label = this.labelKey ? this.chosenOption[this.labelKey] : this.chosenOption;
    } else {
      this.label = this.placeholder;
    }
  }

  setLabel(option: any) {
    if (option) {
      this.label = this.labelKey ? option[this.labelKey] : option;
    } else {
      this.label = this.placeholder;
    }
  }

  isChosen(option: any) {
    const key = !this.valueKey && this.compareKey ? this.compareKey : this.valueKey;
    const useWholeModel = this.valueKey || !this.compareKey;
    if (!this.model && !useWholeModel) {
      return false;
    }
    return (
      (key ? option[key] : option) === (useWholeModel ? this.model : this.model[key])
    );
  }

  isExists(value: string) {
    // eslint-disable-next-line no-param-reassign
    value = value.toLowerCase();
    return (
      this.options.findIndex(
        option =>
          (this.labelKey ? option[this.labelKey] : option).toLowerCase() === value,
      ) !== -1
    );
  }
}
